import { render, staticRenderFns } from "./DataManage.vue?vue&type=template&id=74fcfa1e"
import script from "./DataManage.vue?vue&type=script&lang=js"
export * from "./DataManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports